import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Address {
  id: string;
  streetAddress: string;
  region: string;
  city: string;
  postalCode: string;
}

export interface AddressPayload {
  streetAddress: string;
  region: string;
  city: string;
  postalCode: string;
}

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  constructor(private readonly http: HttpClient) {}

  getAddresses(): Observable<Address[]> {
    return this.http.get<Address[]>(`${environment.apiUrl}/auth/addresses/`, {
      headers: this.buildAuthHeaders(),
    });
  }

  createAddress(payload: AddressPayload): Observable<Address> {
    return this.http.post<Address>(`${environment.apiUrl}/auth/addresses/`, payload, {
      headers: this.buildAuthHeaders(),
    });
  }

  updateAddress(id: string, payload: AddressPayload): Observable<Address> {
    return this.http.patch<Address>(`${environment.apiUrl}/auth/addresses/${id}`, payload, {
      headers: this.buildAuthHeaders(),
    });
  }

  deleteAddress(id: string): Observable<void> {
    return this.http
      .delete(`${environment.apiUrl}/auth/addresses/${id}`, {
        headers: this.buildAuthHeaders(),
      })
      .pipe(map(() => void 0));
  }

  private buildAuthHeaders(): HttpHeaders {
    const accessToken = localStorage.getItem('accessToken');
    return new HttpHeaders({
      Authorization: `Bearer ${accessToken ?? ''}`,
    });
  }
}
